import { vf } from './elements';



/**
***  モーダルウインドウを開く  */
export const modalOpenExec = (contents) => {
  vf.verifyWrapper.classList.add(vf.verifyOpenClass);
  document.body.style.overflow = 'hidden';
  vf.verifyContents.innerHTML = contents;
}



/**
***  モーダルウインドウを閉じる  */
export const modalCloseExec = () => {
  vf.verifyWrapper.classList.remove(vf.verifyOpenClass);
  document.body.style.overflow = '';
  vf.verifyContents.innerHTML = '';
}



// エラーメッセージの出力
export const errorMessage = (str) => {
  return `<span class="error">${str}</span>`;
}



/**
*** フォーム要素が NodeList か
**/

export const isNodeList = (el) => {
  return Object.prototype.toString.call(el) === '[object RadioNodeList]';
}



/**
*** オブジェクト型かチェック
**/
export const isObject = (value) => {
  return value !== null && typeof value === 'object';
}



// オブジェクトの空チェック
export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}



/**
*** rule に含まれているかチェック
**/
export const inRules = (name) => {
  return name in Parameters.rules;
}



/**
*** group に含まれているかチェック
**/
export const getGroupProp = (obj, name) => {
  let property = false;
  if( ! isObjectEmpty(obj) ){
    for( const prop in obj ){
      // group に含まれているか
      const reg = new RegExp('\\b' + name + '\\b');
      if( obj[prop].match(reg) !== null ){
        property = prop;
      };
    }
  }
  return property;
}



/**
*** フォーム要素の type を取得する
**/

export const getType = (obj) => {
  if( obj.length && obj.type === undefined ){
    for( let i = 0; i < 2; i++ ){
      return obj[i].type;
    }
  }
  return obj.type;
}



/**
*** 通常の name  OR group の name を取得する
**/
export const getName = (group, name) => {
  // group に含まれているかチェック 含まれていれば group の name が返ってくる
  const isGroup = getGroupProp(group, name);
  return isGroup ? isGroup : name;
}



/**
*** エラーメッセージを表示する要素を取得する
**/

export const getErrorElement = ( elementName, group ) => {
  // 通常の name  OR group の name を取得する
  const name = getName(group, elementName);
  return document.getElementById( name.replace( /\[\]/g, '' ) + '_error' );
}



/**
*** 指定した name の配列の value を取得して配列として返す
*** @used Pikaday
**/

function getValuesArray( nameArray )
{
  if( nameArray.length <= 0 ) return;
  let arr = [];
  nameArray.forEach( name => {
    arr.push( vivaForm[name].value );
  });
  return arr;
}
